export const formatDisplayCurrency = (amount?: number | string, decimals = 2): string => {
    if (amount === undefined || amount === null) {
        return "0." + "0".repeat(decimals);
    }

    if (typeof amount === "string") {
        amount = Number(amount);
    }

    if (amount < Math.pow(10, -decimals)) {
        return `< 0.${"0".repeat(Math.max(0, decimals - 1))}1`;
    }

    return amount.toLocaleString("en-US", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
};
